import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Card element, used to wrap content and display a white background
 *
 * @slot - Unnamed slot (default slot)
 *
 */
let SDBContentLoader = class SDBContentLoader extends LitElement {
    constructor() {
        super(...arguments);
        this.active = false;
    }
    render() {
        return html ` <div id="loader-container"><div id="loader"></div></div> `;
    }
};
SDBContentLoader.styles = [
    elements,
    css `
            :host {
                display: none;
                position: fixed;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                background: RGBA(0, 0, 0, 0.5);
                z-index: 999;
                -webkit-transform-style: preserve-3d;
                -moz-transform-style: preserve-3d;
                transform-style: preserve-3d;
                text-align: center;
            }

            :host([active]) {
                display: block;
            }

            :host #loader-container {
                display: inline-block;
                width: 300px;
                height: auto;
                position: relative;
                top: 50%;
                transform: translateY(-50%);
            }

            :host #loader {
                background-image: url(/images/hugo-loader.svg);
                background-size: cover;
                width: 100%;
                height: 0;
                padding: 0; /* reset */
                padding-bottom: 100%;
            }
        `,
];
__decorate([
    property({ type: Boolean, reflect: true })
], SDBContentLoader.prototype, "active", void 0);
SDBContentLoader = __decorate([
    customElement('sdb-content-loader')
], SDBContentLoader);
export { SDBContentLoader };
//# sourceMappingURL=sdb-content-loader.js.map